import firebase from 'firebase'
import StoreService from './store'
require('firebase/firestore')

var config = {
    apiKey: "AIzaSyDJJ270Hi84mLuO_yqG8_UPHG5g55fWeJA",
    authDomain: "middleburg-travel.firebaseapp.com",
    databaseURL: "https://middleburg-travel.firebaseio.com",
    projectId: "middleburg-travel",
    storageBucket: "middleburg-travel.appspot.com",
    messagingSenderId: "861474956676"
}
firebase.initializeApp(config)


const firAuth = firebase.auth()
firAuth.onAuthStateChanged(user => {
    if(user && user.uid) {
        StoreService.setUser({
            uid: user.uid,
            email: user.email,
            dispayName: user.dispayName,
        })
    } else {
        StoreService.setUser({})
    }
})

const firestore = firebase.firestore()
firestore.settings({
    timestampsInSnapshots: true,
})
const firStorage = firebase.storage()

export {firAuth, firestore, firStorage}
export default firebase
